module.exports = __webpack_public_path__ + "static/media/cross.16736ae1.svg";